import React from 'react';
import { CountrySelect } from './form/CountrySelect';
import { StateSelect } from './form/StateSelect';
import { statesByCountry } from '../utils/locationData';

interface LocationDropdownsProps {
  state: string;
  country: string;
  onChange: (field: string, value: string) => void;
}

export function LocationDropdowns({ state, country, onChange }: LocationDropdownsProps) {
  const hasStates = country && statesByCountry[country];

  const handleCountryChange = (newCountry: string) => {
    onChange('country', newCountry);
    // Reset state when country changes
    onChange('state', '');
  };

  return (
    <div className="space-y-4">
      <CountrySelect 
        value={country} 
        onChange={handleCountryChange} 
      />
      {hasStates && (
        <StateSelect
          country={country}
          value={state}
          onChange={(value) => onChange('state', value)}
        />
      )}
    </div>
  );
}